import {ServiceBase} from "../ServiceBase";
import {GameVendorDefinition} from "./game-vendor-definition.ts/game-vendor-definition";
import {GameVendorId} from "./game-vendor-id.enum";
import {IGamesVendorService} from "./games-vendor.service.interface";

export class GamesVendorService extends ServiceBase implements IGamesVendorService {

    private _allVendors: GameVendorDefinition[] = [
        new GameVendorDefinition(GameVendorId.V_888, "888"),
        new GameVendorDefinition(GameVendorId.V_AGS, "AGS"),
        new GameVendorDefinition(GameVendorId.V_Amatic, "Amatic"),
        new GameVendorDefinition(GameVendorId.V_Authentic, "Authentic"),
        new GameVendorDefinition(GameVendorId.V_Ainsworth, "Ainsworth"),
        new GameVendorDefinition(GameVendorId.V_Blueprint, "Blueprint"),
        new GameVendorDefinition(GameVendorId.V_Darwin, "Darwin"),
        new GameVendorDefinition(GameVendorId.V_EGT, "Amusnet", ["EGT"]),
        new GameVendorDefinition(GameVendorId.V_Elk, "Elk"),
        new GameVendorDefinition(GameVendorId.V_Evolution, "Evolution"),
        new GameVendorDefinition(GameVendorId.V_Eyecon, "Eyecon"),
        new GameVendorDefinition(GameVendorId.V_GamesGlobal, "Games Global"),
        new GameVendorDefinition(GameVendorId.V_GamingRealms, "Gaming Realms"),
        new GameVendorDefinition(GameVendorId.V_Gamomat, "Gamomat"),
        new GameVendorDefinition(GameVendorId.V_Greentube, "Greentube"),
        new GameVendorDefinition(GameVendorId.V_H5, "H5"),
        new GameVendorDefinition(GameVendorId.V_Habanero, "Habanero"),
        new GameVendorDefinition(GameVendorId.V_IGT, "IGT"),
        new GameVendorDefinition(GameVendorId.V_Inspired, "Inspired"),
        new GameVendorDefinition(GameVendorId.V_iSoftBet, "iSoftBet"),
        new GameVendorDefinition(GameVendorId.V_LightningBox, "Lightning Box"),
        new GameVendorDefinition(GameVendorId.V_LNW, "LNW"),
        new GameVendorDefinition(GameVendorId.V_LNW2, "LNW2"),
        new GameVendorDefinition(GameVendorId.V_Merkur, "Merkur"),
        new GameVendorDefinition(GameVendorId.V_MGA, "MGA"),
        new GameVendorDefinition(GameVendorId.V_NetEnt, "NetEnt"),
        new GameVendorDefinition(GameVendorId.V_NextGenBigTime, "Next_Gen Big Time"),
        new GameVendorDefinition(GameVendorId.V_NextGenChanceInteractive, "NextGen_Chance Interactive"),
        new GameVendorDefinition(GameVendorId.V_NoLimitCity, "Nolimit City"),
        new GameVendorDefinition(GameVendorId.V_PlayNGo, "Play N Go"),
        new GameVendorDefinition(GameVendorId.V_PlayTech, "PlayTech"),
        new GameVendorDefinition(GameVendorId.V_Pragmatic, "Pragmatic"),
        new GameVendorDefinition(GameVendorId.V_Quickspin, "Quickspin"),
        new GameVendorDefinition(GameVendorId.V_RedRake, "Red Rake"),
        new GameVendorDefinition(GameVendorId.V_RedTiger, "Red Tiger"),
        new GameVendorDefinition(GameVendorId.V_RubyPlay, "Ruby Play"),
        new GameVendorDefinition(GameVendorId.V_Sigma, "Sigma"),
        new GameVendorDefinition(GameVendorId.V_Skywind, "Skywind"),
        new GameVendorDefinition(GameVendorId.V_Spribe, "Spribe"),
        new GameVendorDefinition(GameVendorId.V_Thunderkick, "Thunderkick"),
        new GameVendorDefinition(GameVendorId.V_Wizard, "Wizard"),
        new GameVendorDefinition(GameVendorId.V_WMG, "WMG"),
        new GameVendorDefinition(GameVendorId.V_Yggdrasil, "Yggdrasil"),
        new GameVendorDefinition(GameVendorId.V_Everi, "Everi"),
        new GameVendorDefinition(GameVendorId.V_PushGaming, "Push Gaming"),
        new GameVendorDefinition(GameVendorId.V_GoldenRace, "GoldenRace"),
        new GameVendorDefinition(GameVendorId.V_CTXM, "CTXM"),
        new GameVendorDefinition(GameVendorId.V_vsGaming, "vsGaming"),
        new GameVendorDefinition(GameVendorId.V_Electracade, "Electracade"),
        new GameVendorDefinition(GameVendorId.V_Rival, "Rival"),
        new GameVendorDefinition(GameVendorId.V_Dynamite, "Dynamite"),
        new GameVendorDefinition(GameVendorId.V_Ashgaming, "Ashgaming"),
        new GameVendorDefinition(GameVendorId.V_Crypto, "Crypto"),
        new GameVendorDefinition(GameVendorId.V_BlueSq, "BlueSq"),
        new GameVendorDefinition(GameVendorId.V_Bellfruit, "Bellfruit"),
        new GameVendorDefinition(GameVendorId.V_Sportech, "Sportech"),
        new GameVendorDefinition(GameVendorId.V_WagerWorks, "Wager Works"),
        new GameVendorDefinition(GameVendorId.V_Betlow, "Betlow"),
        new GameVendorDefinition(GameVendorId.V_Fremantle, "Fremantle"),
        new GameVendorDefinition(GameVendorId.V_Gamesq, "Gamesq"),
        new GameVendorDefinition(GameVendorId.V_DSL, "DSL"),
        new GameVendorDefinition(GameVendorId.V_Ponsbic, "Ponsbic"),
        new GameVendorDefinition(GameVendorId.V_Endemol, "Endemol"),
        new GameVendorDefinition(GameVendorId.V_Mazooma, "Mazooma"),
        new GameVendorDefinition(GameVendorId.V_Genesis, "Genesis"),
        new GameVendorDefinition(GameVendorId.V_RevolverGaming, "Revolver Gaming"),
        new GameVendorDefinition(GameVendorId.V_Kambi, "Kambi"),
        new GameVendorDefinition(GameVendorId.V_Ingenuity, "Ingenuity"),
        new GameVendorDefinition(GameVendorId.V_UniversalStudios, "Universal Studios"),
        new GameVendorDefinition(GameVendorId.V_BallyWulff, "Bally Wulff"),
        new GameVendorDefinition(GameVendorId.V_Skilzz, "Skilzz"),
        new GameVendorDefinition(GameVendorId.V_NorthernLight, "Northern Light"),
        new GameVendorDefinition(GameVendorId.V_Gamevy, "Gamevy"),
        new GameVendorDefinition(GameVendorId.V_Playson, "Playson"),
        new GameVendorDefinition(GameVendorId.V_Spectate, "Spectate"),
        new GameVendorDefinition(GameVendorId.V_PGSoft, "PGSoft"),
        new GameVendorDefinition(GameVendorId.V_RFranco, "RFranco"),
        new GameVendorDefinition(GameVendorId.V_4theplayer, "4theplayer"),
        new GameVendorDefinition(GameVendorId.V_Realistic, "Realistic"),
        new GameVendorDefinition(GameVendorId.V_Oryx, "Oryx"),
        new GameVendorDefinition(GameVendorId.V_ReelPlay, "Reel Play"),
        new GameVendorDefinition(GameVendorId.V_Hacksaw, "Hacksaw"),
        new GameVendorDefinition(GameVendorId.V_1x2, "1x2"),
        new GameVendorDefinition(GameVendorId.V_Leap, "Leap"),
        new GameVendorDefinition(GameVendorId.V_Core, "Core"),
        new GameVendorDefinition(GameVendorId.V_ReelNRG, "ReelNRG"),
        new GameVendorDefinition(GameVendorId.V_IronDog, "IronDog"),
        new GameVendorDefinition(GameVendorId.V_Endorphina, "Endorphina"),
        new GameVendorDefinition(GameVendorId.V_Betsoft, "Betsoft"),
        new GameVendorDefinition(GameVendorId.V_Playzido, "Playzido"),
        new GameVendorDefinition(GameVendorId.V_PlayzidoOthers, "Playzido Others"),
        new GameVendorDefinition(GameVendorId.V_TomHorn, "Tom Horn"),
        new GameVendorDefinition(GameVendorId.V_NeoGames, "Neo Games"),
        new GameVendorDefinition(GameVendorId.V_BFGames, "BFGames"),
        new GameVendorDefinition(GameVendorId.V_Kalamba, "Kalamba"),
        new GameVendorDefinition(GameVendorId.V_GiveMe, "Give Me"),
        new GameVendorDefinition(GameVendorId.V_GoldenHero, "Golden Hero"),
        new GameVendorDefinition(GameVendorId.V_2by2, "2by2"),
        new GameVendorDefinition(GameVendorId.V_PlankGaming, "Plank Gaming"),
        new GameVendorDefinition(GameVendorId.V_BulletproofGames, "Bulletproof Games"),
        new GameVendorDefinition(GameVendorId.V_Wazdan, "Wazdan"),
        new GameVendorDefinition(GameVendorId.V_PlayzidoReelplay, "Playzido Reelplay"),
        new GameVendorDefinition(GameVendorId.V_Gong, "Gong"),
        new GameVendorDefinition(GameVendorId.V_DWG, "DWG"),
        new GameVendorDefinition(GameVendorId.V_TripleCherry, "Triple Cherry"),
        new GameVendorDefinition(GameVendorId.V_Spearhead, "Spearhead"),
        new GameVendorDefinition(GameVendorId.V_Spinomenal, "Spinomenal"),
        new GameVendorDefinition(GameVendorId.V_CIRSA, "CIRSA"),
        new GameVendorDefinition(GameVendorId.V_Funfair, "Funfair"),
        new GameVendorDefinition(GameVendorId.V_GreenJade, "GreenJade"),
        new GameVendorDefinition(GameVendorId.V_NazionaleElectronica, "Nazionale Electronica"),
        new GameVendorDefinition(GameVendorId.V_Booming, "Booming"),
        new GameVendorDefinition(GameVendorId.V_Betixon, "Betixon"),
        new GameVendorDefinition(GameVendorId.V_NetGaming, "Net Gaming"),
        new GameVendorDefinition(GameVendorId.V_BGaming, "BGaming"),
        new GameVendorDefinition(GameVendorId.V_BlueHorn, "Blue Horn"),
        new GameVendorDefinition(GameVendorId.V_SpinPlay, "Spin Play"),
        new GameVendorDefinition(GameVendorId.V_Arcadia, "Arcadia"),
        new GameVendorDefinition(GameVendorId.V_Stakelogic, "Stakelogic"),
        new GameVendorDefinition(GameVendorId.V_Live5, "Live5"),
        new GameVendorDefinition(GameVendorId.V_Swintt, "Swintt"),
        new GameVendorDefinition(GameVendorId.V_Edict, "Edict"),
        new GameVendorDefinition(GameVendorId.V_GameArt, "Game Art"),
        new GameVendorDefinition(GameVendorId.V_LadyLuck, "Lady Luck"),
        new GameVendorDefinition(GameVendorId.V_SmartSoft, "SmartSoft"),
        new GameVendorDefinition(GameVendorId.V_Spinberry, "Spinberry"),
        new GameVendorDefinition(GameVendorId.V_TopSpin, "Top Spin"),
        new GameVendorDefinition(GameVendorId.V_eZugi, "eZugi"),
        new GameVendorDefinition(GameVendorId.V_IndigoMagic, "Indigo Magic"),
        new GameVendorDefinition(GameVendorId.V_AtomicLabs, "Atomic Labs"),
        new GameVendorDefinition(GameVendorId.V_Bluberi, "Bluberi"),
        new GameVendorDefinition(GameVendorId.V_RAW, "RAW"),
        new GameVendorDefinition(GameVendorId.V_Reevo, "Reevo"),
        new GameVendorDefinition(GameVendorId.V_WhiteHat, "White Hat"),
        new GameVendorDefinition(GameVendorId.V_EGTDigital, "EGT Digital")
    ];

    findVendors(regEx: RegExp): number[] {
        const foundVendors: number[] = [];

        this._allVendors.forEach(theme => {
            if (theme.isMatch(regEx)) {
                foundVendors.push(theme.id)
            }
        })

        return foundVendors;
    }
    getVendor(gameVendorId: number): GameVendorDefinition {
        return this._allVendors.find(gameThemeDefinition => gameThemeDefinition.id === gameVendorId);
    }
}